import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_AI_SUMMARIES_ENABLED = defineFcm('petition_page_ai_summaries_enabled')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: {
					type: 'string',
					description: 'The name of the experiment to use for AI summaries on the Petition Details page.',
				},
				enabled: {
					type: 'boolean',
					default: false,
					description: 'Whether AI-generated summaries are enabled on the Petition Details page.',
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-middle-end',
		context: 'Petition Details page',
		description: 'Controls whether AI-generated title and description are displayed on the Petition Details page.',
		import: false,
		template: {
			enabled: false,
			experiment_name: 'petition_page_ai_summaries_enabled_experiment',
		},
	});
